import { render, staticRenderFns } from "./buttonWithIcon.vue?vue&type=template&id=42b4f311&"
import script from "./buttonWithIcon.vue?vue&type=script&lang=js&"
export * from "./buttonWithIcon.vue?vue&type=script&lang=js&"
import style0 from "./buttonWithIcon.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports